import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/contexts/AuthContext';
import IntroVideo from '@/components/IntroVideo';
import { Loader2 } from 'lucide-react';

export default function SplashScreen() {
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAuth();
  const { t } = useTranslation();

  // Authenticated users: brief brand splash, then redirect to
  // dashboard. Logged-out users get the intro video below.
  useEffect(() => {
    if (loading || !isAuthenticated) return;
    const timer = setTimeout(() => {
      navigate('/dashboard', { replace: true });
    }, 1800);
    return () => clearTimeout(timer);
  }, [loading, isAuthenticated, navigate]);

  // Authenticated (or still loading) — plain brand splash while
  // we redirect.
  if (loading || isAuthenticated) {
    return (
      <div className="min-h-screen bg-farm-primary flex flex-col items-center justify-center animate-fadeIn">
        <div className="text-center">
          <span className="text-8xl mb-4 block">🌾</span>
          <h1 className="text-3xl font-bold text-white mb-2">{t('splash.brand')}</h1>
          <p className="text-white/90 text-lg">{t('splash.tagline')}</p>
        </div>
        <Loader2 className="w-8 h-8 text-white mt-10 animate-spin" />
        <p className="text-white/70 mt-4 text-sm">{t('splash.loading')}</p>
      </div>
    );
  }

  // Logged out: the intro video, with its language choice. It replaced
  // the green splash and the onboarding slides; Skip, Continue and the
  // end of the video all go to login.
  return <IntroVideo />;
}
